import { render, staticRenderFns } from "./privacy-summary.vue?vue&type=template&id=31993064&scoped=true"
import script from "./privacy-summary.vue?vue&type=script&lang=js"
export * from "./privacy-summary.vue?vue&type=script&lang=js"
import style0 from "./privacy-summary.vue?vue&type=style&index=0&id=31993064&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_6szsw7whnsew6zajutnmcgkloi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31993064",
  null
  
)

export default component.exports